@if (isLoggedIn) {
  <div>
    <p-tabView [(activeIndex)]="activeIndex" #tabview>
      <p-tabPanel header="Account Settings" headerStyleClass="config-tab" [selected]="true">
        <account-editor></account-editor>
      </p-tabPanel>
      <!-- Sharing can be managed from the Nework List -->
      <!--<p-tabPanel header="Manage Sharing" headerStyleClass="config-tab">
      <share-manager></share-manager>
    </p-tabPanel>-->
    <p-tabPanel header="Manage API Keys" headerStyleClass="config-tab">
      <apikey-list></apikey-list>
    </p-tabPanel>
  </p-tabView>
</div>
}